import {ITEM_TYPE} from 'am-constants';

function checkIfItemIsLink (item) {
  return item.itemTypeId === ITEM_TYPE.LINK;
}

export default checkIfItemIsLink;
